<div class="week-selector">
  <div class="d-flex align-items-center justify-content-between">
    <button
      class="btn btn-outline-secondary btn-primary"
      (click)="previousWeek()"
    >
      <span>&lt;</span>
    </button>

    <div class="week-display" (click)="openDatePicker()">
      <input
        #datePicker
        type="date"
        class="date-picker-input"
        [value]="getDatePickerValue()"
        (change)="onDateSelected($event)"
      />
      <span class="week-range-label">{{ selectedWeekStart.getFullYear() }}</span>
      <span class="week-range">
        {{ selectedWeekStart | date: "MMM dd" }} - {{ selectedWeekEnd | date: "MMM dd" }}
      </span>
    </div>

    <div class="d-flex align-items-center gap-2">
      <button
        class="btn btn-outline-secondary btn-primary"
        (click)="nextWeek()"
        [disabled]="!canGoToNextWeek()"
      >
        <span>&gt;</span>
      </button>
      <button
        [disabled]="isCurrentWeek()"
        class="btn btn-outline-secondary btn-primary"
        (click)="initializeCurrentWeek()"
      >
        <span>Today</span>
      </button>
    </div>
    <div class="spinner-div">
      @if(isLoading){
      <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
      }
    </div>
  </div>
</div>
